import React from 'react';
import PropTypes from 'prop-types';
import { GraphLine, InfoText, Numbers } from '@weezevent/nacre';
import css from './eventGraph.module.css';

export default function EventGraph({ count, quota, subtitle, locale }) {
    return (
        <div className={css['event-graphline']}>
            <div className={css['graphline-values']}>
                <span className={css['value-count']}>
                    <Numbers value={count} locale={locale} />
                </span>
                <span className={css['value-quota']}>
                    <span>{'/ '}</span>
                    <Numbers value={quota} locale={locale} />
                </span>
            </div>
            <GraphLine tooltip max={quota} value={count} />
            <InfoText className={css['graphline-subtitle']} subtitle={subtitle} />
        </div>
    );
}

EventGraph.propTypes = {
    count: PropTypes.number,
    quota: PropTypes.number,
    subtitle: PropTypes.string,
    locale: PropTypes.string
};

EventGraph.defaultProps = {
    count: 0,
    quota: 0,
    subtitle: null,
    locale: 'en'
};
